/* eslint-disable no-useless-escape */
import { ColDef } from 'ag-grid-community';
import { SelectProps, Spin, TableColumnsType, Tooltip, TreeSelectProps } from 'antd';
import dayjs from "dayjs";
import { isArray } from 'lodash';
import { useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import * as CustomerApi from '../src/api/customer/customerApi';
import * as customerCareApi from '../src/api/customerCare/customerCareApi';
import * as IssuedCardsApi from '../src/api/rank/issuedCardApi';
import * as RankApi from '../src/api/rank/rankApi';
import * as selectOptionsApi from '../src/api/selectOptions/selectOptionsApi';
import { IGeneralConfiguration, IProvider } from './api/generalConfiguration/generalConfigurationApi';
import { IOperatorFieldConditionsGroup, IVConditionFilterADD } from './api/groupCustomerV2/groupCustomerV2Api';
import { changePermissionUnit, IPermission } from './api/login/loginApi';
import { IMessageVariables } from './api/marketing/templateApi';
import { getListMenuByUnitAndPermission, IMenu } from './api/menu/MenuApi';
import { INetwork } from './api/network/networkApi';
import { ICustomerFields } from './api/salesSericeCustomer/salesSericeCustomerApi';
import { IAllCustomer, ICarForInfomation, ICustomerTypes, IRelative, ISelectOption, IStaff, ITypeZNS } from './api/selectOption/selectOptionsApi';
import { getListUnitByUserPermission, IUnitByUserPermission } from './api/unitByUserPermission';
import { ColumnKey, DataType } from './pages/Customers/Tabs/CarListCardClone';
import FilterHeader from './pages/CustomersV2/FilterHeader';
import { IDataDefaulFilterList, OptionData } from './pages/CustomersV2/indexV2';
import { OptionSelect_V2 } from './services/fomartUnit';
import { selectorPermission, setPermission } from './store/slices/permissionSlice';
import { setUnitByUserPermission } from './store/slices/UnitByUserPermission';
import { ModuleTypeLog, NO_DATA } from './services/data';
import { alwaysPageAllowed, alwaysPageAllowedNotKey, MAX_DIGITS } from './env';
import { setMenu } from './store/slices/menuSlice';
import { DatePickerProps } from 'antd/lib';
import { HistorySummary, ICustomer, IItemLast, VehiclePlateNumber } from './api/Customer_V2/customerApi_V2';
import { ISLGroup } from './api/groupCustomer/groupCustomerApi';
import { setCategoryCar } from './store/slices/categoryCarSlice';
import { IIssuingUnit } from './api/unit/unitApi';
import { ISystemLog } from './api/groupPermission/groupPermissionApi';
import { Link } from 'react-router-dom';
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Group } from './api/paramCRM/paramCRMApi';

const Status = [
  {
    value: 0,
    title: "Chờ gửi",
    color: "#FAAD14"
  },
  {
    value: 1,
    title: "Đang gửi",
    color: "#1890FF"
  },
  {
    value: 2,
    title: "Hoàn thành",
    color: "#52C41A"
  },
  {
    value: 3,
    title: "Tạm dừng",
    color: "#EC2D30"
  }
]

export const paserParams = (params: any, valueIsFail: any, allow?: CheckValueOptions) => {
  for (let i in params) {
    if (typeof (params[i]) === 'object') {
      params[i] = paserParams(params[i], valueIsFail, allow)
    } else {
      params[i] = parseValue(params[i], valueIsFail, allow)
    }
  }
  return params
}

export const parseValue = (value: any, valueIsFail: any, allow?: CheckValueOptions) => {

  if (!allow?.isNull) {
    if (value == null) {
      return valueIsFail;
    }
    if (Number.isNaN(value)) {
      return valueIsFail;
    }
  }

  if (!allow?.isEmpty) {
    if (['string', 'object'].includes(typeof (value)) && value.length === 0) {
      return valueIsFail;
    }
  }
  return value;
}
interface CheckValueOptions {
  isEmpty?: boolean,
  isNull?: boolean,
}

export const dataPagination = (totalRow: number, rowNumber: number, currentPage: number) => {

  var tongTrang = Math.ceil(totalRow / rowNumber) === 0 ? 1 : Math.ceil(totalRow / rowNumber)
  var tongDongTrangCuoi = totalRow - (rowNumber * (Math.floor(totalRow / rowNumber)))
  var hienThiTu = rowNumber * currentPage
  var hienThiDen = rowNumber * (currentPage + 1)
  return {
    totalPage: formatPrice(tongTrang ?? 0),
    currentPage: currentPage,
    totalLastLine: tongDongTrangCuoi,
    hienThiTu: hienThiTu,
    hienThiDen: hienThiDen
  }
}

export const regexPhoneNumber = (phone: selectOptionsApi.Phone[]) => {
  const regexPhoneNumber = /(84|0[3|5|7|8|9])+([0-9]{8})\b/g;
  const validate = phone.map((item) => {
    return item.phone.match(regexPhoneNumber) ? true : false
  })
  return validate
}
export const validateEmail = (email: string): boolean => {
  // Regular expression for validating email addresses
  const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  return emailRegex.test(email);
};
// cấu hình nhà mạng
export const fommatSelectOptionProviderConfig = (arr: IGeneralConfiguration[]) => {
  const newData = arr?.map(item => ({
    value: item.id,
    label: item.brandName
  }));
  return newData
}
// tham số
export const fommatSelectOptionMessageVariables = (arr: IMessageVariables[]) => {
  const newData = arr?.map(item => ({
    value: item.id,
    label: item.parameterKey
  }));
  return newData
}
// người tạo
export const fommatSelectOptionCreator = (arr: IStaff[] | IAllCustomer[]) => {
  const newData = arr?.map(item => ({
    value: item.id,
    label: item.username
  }));
  return newData
}

// chủ sở hữu mới
export const fommatSelectOptionCustomerV2 = (arr: IAllCustomer[]) => {
  // console.log(arr[0].code)
  const newData = arr?.map(item => ({
    value: item.id,
    label: `${item.username} (${item.code})`
  }));
  return newData
}
// giới tính
export const fommatdataDefault = (arr: {
  value: number,
  title: string
}[]) => {
  const newData = arr?.map(item => ({
    id: item.value,
    title: item.title
  }));
  return newData
}
export const fommatdataType = (arr: {
  value: number,
  label: string
}[]) => {
  const newData = arr?.map(item => ({
    id: item.value,
    title: item.label
  }));
  return newData
}

export const fommatdataCodeCustomer = (arr: selectOptionsApi.ICodeCustomer[]) => {
  const newData = arr?.map(item => ({
    id: item.code,
    title: item.code
  }));
  return newData
}
export const fommatdataRank = (arr: any[]) => {
  const newData = arr?.map(item => ({
    id: item.id,
    title: item.title
  }));
  return newData
}

export const fommatSelectOption = (
  arr: selectOptionsApi.ICarCompany[] | selectOptionsApi.IRelative[] | RankApi.IRank[] | IssuedCardsApi.IListRankEdit[] | selectOptionsApi.IListAgent[] | selectOptionsApi.IUnitOption[] | IProvider[] | INetwork[] | ITypeZNS[] | selectOptionsApi.provinceUnit[] | ICustomerTypes[] | selectOptionsApi.ICategoryCar[]
) => {
  const newData = arr?.map(item => ({
    value: 'vehicleId' in item && item.vehicleId ? item.vehicleId : item.id,
    label: 'code' in item && item.code ? item.code : item.title
  }));
  return newData
}


export const fommatSelectOptionV2 = (
  arr: selectOptionsApi.ICarCompany[] | selectOptionsApi.IRelative[] | RankApi.IRank[] | IssuedCardsApi.IListRankEdit[] | selectOptionsApi.IListAgent[] | selectOptionsApi.IUnitOption[] | IProvider[] | INetwork[] | ITypeZNS[] | selectOptionsApi.provinceUnit[] | ICustomerTypes[] | selectOptionsApi.ICategoryCar[]
) => {
  const newData = arr?.map(item => ({
    value: 'vehicleId' in item && item.vehicleId ? item.vehicleId : item.id,
    label: item.title
  }));
  return newData
}

export const fommatSelectOptionToUpperCase = (
  arr: selectOptionsApi.ICarCompany[] | selectOptionsApi.IRelative[] | RankApi.IRank[] | IssuedCardsApi.IListRankEdit[] | selectOptionsApi.IListAgent[] | selectOptionsApi.IUnitOption[] | IProvider[] | INetwork[] | ITypeZNS[] | selectOptionsApi.provinceUnit[] | ICustomerTypes[] | selectOptionsApi.ICategoryCar[] | Group[]
) => {
  const newData = arr?.map(item => ({
    value: item.id,
    label: 'code' in item && item.code ? item.code : item.title?.toUpperCase()
  }));
  return newData
}

export const fommatSelectOptionTitle = (
  arr: selectOptionsApi.ICarCompany[] | selectOptionsApi.IRelative[] | RankApi.IRank[] | IssuedCardsApi.IListRankEdit[] | selectOptionsApi.IListAgent[] | selectOptionsApi.IUnitOption[] | IProvider[] | INetwork[] | ITypeZNS[] | selectOptionsApi.provinceUnit[] | ICustomerTypes[] | selectOptionsApi.ICategoryCar[] | Group[]
) => {
  const newData = arr?.map(item => ({
    value: item.id,
    label: item.title
  }));
  return newData
}


export const fommatSelectOptionHasCount = (
  arr: ISLGroup[]
) => {
  const newData = arr?.map(item => ({
    value: item.id,
    label: <span>{item.title}<span className='custom-page-css text-1890FF pl-1'>({item.countCustomer})</span> </span>
  }));
  return newData
}


export const fommatSelectOptionUnit = (
  arr: selectOptionsApi.IUnitOption[]
) => {
  const newData = arr?.map(item => ({
    value: item.id,
    label: `${item.title} (${item.code})`
  }));
  return newData
}


export const fommatSelectOptionPlate = (
  arr: VehiclePlateNumber[]
) => {
  const newData = arr?.map(item => ({
    value: item.id,
    label: item.plateNumber
  }));
  return newData
}

export const fommatSelectOptionListType = (arr: ICustomerTypes[]) => {
  return arr.map((item) => ({
    value: item.id,
    label: (
      <div
        style={{
          backgroundColor: `#${item.backgroundColor}`,
          color: `#${item.color}`,
          padding: '2px 8px',
          borderRadius: '4px',
          fontSize: 12,
          fontWeight: 500,
          display: 'inline-block',
          width: 'fit-content',
        }}
      >
        {item.code}
      </div>
    ),
    title: item.title,
    code: item.code,
    color: `#${item.color}`,
    backgroundColor: `#${item.backgroundColor}`,
  }));
}

export const fommatSelectOptionCustomerTypes = (arr: ICustomerTypes[]) => {
  const newData = arr?.map(item => ({
    value: item.id,
    label: item.title,
    color: item.color,
    backgroundColor: item.backgroundColor,
    code: item.code,
    codeSymbol: item?.codeSymbol
  }));
  return newData
}
export const formatGroupColor = (data: IRelative) => {
  const newData = {
    value: data?.id.toString(),
    label: data?.title
  }
  return newData
}
export const fommatSelectOptionData = (arr: {
  value: number;
  title: string;
}[]) => {
  const newData = arr?.map(item => ({
    value: item.value,
    label: item.title
  }));
  return newData
}

export const fommatSelectOptionCustomer = (arr: CustomerApi.ICustomer[]) => {
  const newData = arr?.map(item => ({
    value: item.id,
    label: item.name
  }));
  return newData
}
export const fommatSelectOptionAdmin = (arr: customerCareApi.Admin[]) => {
  const newData = arr?.map(item => ({
    value: item.id,
    label: item.fullname + `(${item.code})`
  }));
  return newData
}
export const fommatSelectOptionUnitByUser = (arr: IUnitByUserPermission[]) => {
  const newData = arr?.map(item => ({
    value: item.unitId,
    label: item.unitTitle
  }));
  return newData
}
// Functions xử lý khi có parent ID để find ra title Vùng miền. Toàn quốc
export function findParentIdLevelOne(units: selectOptionsApi.dataConvert[], targetId: number | null, level: number): string {
  if (targetId === null) {
    return '';
  }
  const data = units.find((item) => item.id === targetId);
  if (data?.level === level) {
    return data.title;
  } else {
    return findParentIdLevelOne(units, data?.parentId ?? null, level);
  }
}

export function flattenDonViArray(arr: selectOptionsApi.UnitLevel[]): selectOptionsApi.dataConvert[] {
  const result: { id: number, title: string, level: number, parentId: number | null }[] = [];

  function traverse(data: selectOptionsApi.UnitLevel[]) {
    for (const item of data) {
      result.push({ id: item.id, title: item.title, level: item.level, parentId: item.parentId });
      if (item.children && item.children.length > 0) {
        traverse(item.children);
      }
    }
  }
  traverse(arr);
  return result;
}

export const formatPrice = (val: number | string | undefined) => {
  if (val != undefined) {
    let v = val.toString();
    return v.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  } else {
    return "";
  }
};

export const formatPriceV2 = (val: number | string | undefined) => {
  if (val != undefined) {
    let v = val.toString();
    return v.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return "";
  }
};

// Tắng % khi fill input add customer
export const changePercent = (percent: number, percentUp: number, stringOld: string, stringNew: string) => {
  if (stringNew.length && !stringOld.length) {
    return (percent + percentUp)
  } else {
    if (stringOld.length && !stringNew.length) {
      return (percent - percentUp)
    }
    else {
      return percent
    }

  }
}

export const changePercentDate = (percent: number, percentUp: number, stringOld: string, stringNew: string) => {
  if (stringNew !== null && !stringOld.length) {
    return (percent + percentUp)
  } else {
    if (stringOld.length && stringNew === null) {
      return (percent - percentUp)
    }
    else {
      return percent
    }

  }
}


export const changePercentGroup = (percent: number, percentUp: number, stringOld: number[], stringNew: number[]) => {
  if (stringNew.length !== 0 && !stringOld.length) {
    return (percent + percentUp)
  } else {
    if (stringNew.length === 0) {
      return (percent - percentUp)
    }
    else {
      return percent
    }

  }
}

export const fomartListAreaAndListProvince = (data: string[]) => {
  let ListArea: number[] = [], listProvince: number[] = [];
  const uniqueListArea = new Set<number>();

  data.forEach((acc) => {
    const xx = acc.toString()
    const [before, after] = xx.split('-');
    const area = +before;
    if (!uniqueListArea.has(area)) {
      ListArea.push(area);
      uniqueListArea.add(area);
    }
    if (after) {
      listProvince.push(+after);
    }
  });

  return { ListArea, listProvince };
};


export const convertStringToHTML = (value: string) => {
  return <div dangerouslySetInnerHTML={{ __html: value }} ></div>
}

export const exportExcel = (convertData: any, message?: string): boolean => {

  try {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(convertData);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Danh sách');

    const excelBuffer: ArrayBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });

    const saveAsExcel = (buffer: ArrayBuffer, fileName: string): void => {
      const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
      const link: HTMLAnchorElement = document.createElement('a');
      link.href = window.URL.createObjectURL(data);
      link.download = fileName;
      link.click();
    };
    saveAsExcel(excelBuffer, `${message}.xlsx`);
    return true; // Export successful
  } catch (error) {
    console.error('Error exporting Excel:', error);
    return false; // Export failed
  }


}
export const handleDateChangeDayJs = (dateValue: any): string => {
  if (dateValue && dateValue.isValid && dateValue.isValid()) {
    const dateString = dateValue.format('DD/MM/YYYY');
    return dateString
  } else {
    return ""
  }
};

export const handleDateChangeDayJsV2 = (dateValue: any): string => {
  if (dateValue && dateValue.isValid && dateValue.isValid()) {
    const dateString = dateValue.format('YYYY/MM/DD');
    return dateString
  } else {
    return ""
  }
};

export const handleDateChangeDayJsGroup = (dateValue: any): string => {
  if (dateValue && dateValue.isValid && dateValue.isValid()) {
    const dateString = dateValue.format('DD/MM/YYYY');
    return dateString
  } else {
    return ""
  }
};

export const handleDateChangeDayJsGroupDayMonth = (dateValue: any): string => {
  if (dateValue && dateValue.isValid && dateValue.isValid()) {
    const dateString = dateValue.format('DD/MM');
    return dateString
  } else {
    return ""
  }
};

export const handleStringToDayJs = (dateString?: string) => {
  if (dateString) {
    const dateValue = dayjs(dateString, "YYYY/MM/DD", true);
    return dateValue.isValid() ? dateValue : undefined;
  }
  return undefined;
};

export const handleStringToDayJsV2 = (dateString?: string) => {
  if (dateString) {
    const dateValue = dayjs(dateString, "DD/MM/YYYY", true);
    return dateValue.isValid() ? dateValue : undefined;
  }
  return undefined;
};


export const handleStringToDayJsV3 = (dateString?: string) => {
  if (dateString) {
    const dateValue = dayjs(dateString, "YYYY/MM/DD", true);
    return dateValue.isValid() ? dateValue : undefined;
  }
  return undefined;
};
export const handleStringToDayJsV4 = (dateString?: string) => {
  if (dateString) {
    const dateValue = dayjs(dateString, "DD/MM/YYYY", true);
    return dateValue.isValid() ? dateValue : undefined;
  }
  return undefined;
};
/**
 * Chuyển chuỗi ngày từ định dạng "yyyy-mm-dd" sang "dd/mm/yyyy"
 * @param dateStr Chuỗi ngày đầu vào dạng "2025-04-02"
 * @returns Chuỗi ngày dạng "02/04/2025" hoặc "" nếu đầu vào không hợp lệ
 */
export function formatDateToDMY(dateStr: string | null | undefined): string | undefined {
  if (!dateStr || dateStr.trim() === "")
    return undefined;

  const parts = dateStr.split(/[-/]/);
  if (parts.length !== 3) return undefined;

  const [part1, part2, part3] = parts;
  if (part1.length === 4) {
    return `${part1}/${part2}/${part3}`;
  }
  return `${part1}/${part2}/${part3}`;
}

export function formatDateToDMYGroup(dateStr: string | null | undefined): string | undefined {
  if (!dateStr || dateStr.trim() === "")
    return undefined;

  const parts = dateStr.split(/[-/]/);
  if (parts.length !== 3) return undefined;

  const [part1, part2, part3] = parts;
  if (part1.length === 4) {
    return `${part3}/${part2}/${part1}`;
  }
  return `${part3}/${part2}/${part1}`;
}

/**
 * Hàm dùng để lấy label từ mảng `selectOptions` theo `id`,
 * chỉ dành cho hiển thị đơn thuần.
 *
 * @param arr - Mảng các tùy chọn, mỗi tùy chọn có cấu trúc { value, label }
 * @param id - Giá trị cần tìm trong mảng
 * @returns Label tương ứng hoặc "Không tìm thấy" nếu không tồn tại
 */
export const getTitleSelectOption = (arr: selectOptionsApi.ISelectOption[], id: number, text?: string): string => {
  const item = arr.find((item) => item.value === id);
  return item?.label ?? (text ?? NO_DATA);
}

export const getTitleSelectOption_V2 = (arr: selectOptionsApi.ISelectOption[], id: number, count?: number, text?: string) => {
  const item = arr.find((item) => item.value === id);
  return (<span>{item?.label ?? (text ?? NO_DATA)} {count && `(${count})`} </span>)
}

export const findChildIdByUrl = (menus: IMenu[], menuUrl: string) => {
  const permissionSlice = useSelector(selectorPermission)
  let menutmp = {
    menuId: 1,
    access: false,
    add: false,
    edit: false,
    delete: false,
    upload: false,
    download: false,
    share: false,
  }

  for (const menu of menus) {
    const foundChild = menu.childrenMenu && menu.childrenMenu.find(child => child.menuUrl === menuUrl);
    if (foundChild)
      menutmp = permissionSlice.find((val => val.menuId == foundChild.id)) ?? menutmp

  }
  return menutmp
};


export const checkIsViewAndIsEdit = (isView: boolean = false, isEdit: boolean = false) => {
  if (isEdit)
    return ""
  else if (isView)
    return " event-none-form-item  event-none-radio event-none-Flex"
  else return " d-none-form-item d-none-edit event-none-radio d-none-radio event-none-Flex d-none-Flex d-none"
}

export const checkIsValue = (value?: string) => {
  if (value)
    return "item"
  else
    return "d-none"

}
// export const gPermissionUser = async (unitId: number, groupPermissionId?: number, dispatch?: any) => {
//   const result = await permissionUser(unitId, groupPermissionId)
//   if (result?.status) {
//     dispatch(setPermission(result.dataMenu))
//     dispatch(setdataPermissionCustomer(result.dataPermissionCustomer))
//   }
// }
export const gPermissionUnit = async (adminId: number, unitId: number, dispatch?: any) => {
  const result = await changePermissionUnit(adminId, unitId)

  if (result?.status) {
    dispatch(setPermission(result.dataMenu))
  }
}


export const setMenuAndPermission = async (
  unitId: number, dispatch: any, navigate: any, pathname: string
) => {

  const result = await getListMenuByUnitAndPermission(unitId)
  if (result?.status) {
    const { dataMenu, dataPermission, dataCategoryCar } = result.data
    dispatch(setPermission(dataPermission))
    dispatch(setMenu(dataMenu))
    dispatch(setCategoryCar(dataCategoryCar))

    switch (pathname) {
      case "/login": {
        const deepestUrl = getDeepestFirstChildUrl(dataMenu);
        navigate(deepestUrl ?? "/unauthorized")
        break;
      }
      case "/unauthorized":
      case "/*": {
        const deepestUrl = getDeepestFirstChildUrl(dataMenu);
        navigate(deepestUrl ?? "/unauthorized")
        break;
      }
      default: {
        if (!pathname)
          return
        if (isCurrentPathInMenu(dataMenu, dataPermission, pathname)) {

        } else {
          const deepestUrl1 = getDeepestFirstChildUrl(dataMenu);
          navigate(deepestUrl1)
          break;
        }
      }

    }
  }
}
// danh sách đơn vị theo quyền người dùng
export const gListUnitByUserPermission = async (id: number, dispatch?: any, search?: string) => {
  const result = await getListUnitByUserPermission(search)
  if (result?.status) {
    dispatch(setUnitByUserPermission(result?.data))
  } else {
  }
}

/**
 * Hàm dùng để lọc một cây `nodes` theo danh sách `dataB`,
 * loại bỏ các node có `id` trùng với `unitId` trong `dataB`.
 *
 * @param nodes - Mảng các node gốc, mỗi node phải có ít nhất 2 thuộc tính:
 *   - `id: number`
 *   - `children: T[]`
 * @param dataB - Mảng `listUnitPer`, mỗi phần tử có:
 *   - `unitId: number` (ID của node cần loại bỏ)
 *   - `unitTitle: string` (không dùng trong lọc)
 * @returns Mảng các node sau khi lọc, vẫn giữ nguyên cấu trúc cây:
 *   - Toàn bộ node (và subtree) có `id` nằm trong `dataB.map(d => d.unitId)` bị loại bỏ.
 *   - Các node còn lại được giữ lại cùng `children` đã được lọc đệ quy.
 */
export function filterDuplicateUnit<T extends { id: number; children: T[] }>(
  nodes: OptionSelect_V2[],
  dataB: { unitId: number; unitTitle: string, groupPermissionId: number }[]

): OptionSelect_V2[] {
  const idsToRemove = new Set<number>(dataB.map(d => d.unitId));

  return nodes.reduce<OptionSelect_V2[]>((acc, node) => {
    if (!node || node.value === undefined) return acc;
    if (idsToRemove.has(node.value)) return acc;
    acc.push({
      ...node,
      children: filterDuplicateUnit(node.children, dataB)
    });
    return acc;
  }, []);
}

/**
 * Loại bỏ tất cả các node có `value` nằm trong `idsToRemove`,
 * đồng thời đệ quy xuống children.
 */
export function filterDuplicateUnitV2(
  nodes: OptionSelect_V2[],
  idsToRemove: number[]
): OptionSelect_V2[] {
  const removeSet = new Set<number>(idsToRemove);

  return nodes.reduce<OptionSelect_V2[]>((acc, node) => {
    // nếu node này cần loại bỏ thì skip
    if (removeSet.has(node.value)) {
      return acc;
    }

    // nếu có children thì đệ quy lọc,
    // nếu không có children, đảm bảo để thành []
    const filteredChildren = node.children
      ? filterDuplicateUnitV2(node.children, idsToRemove)
      : [];

    acc.push({
      ...node,
      // nếu không muốn thêm trường children khi rỗng, bạn có thể kiểm tra filteredChildren.length > 0
      children: filteredChildren
    });

    return acc;
  }, []);
}
// Hàm thay thế parameterKey bằng fieldLabel cho preview
// Hàm thay thế parameterKey bằng fieldLabel cho preview
export const replaceVariables = (content: string, data: IMessageVariables[]): string => {
  let newContent = content;
  data.forEach((item) => {
    const regex = new RegExp(
      item.parameterKey.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'),
      'ig'
    );
    newContent = newContent?.replace(regex, item.fieldLabel);
  });
  return newContent;
};

export const formatDate = (arr: string[]) => {

  const [start, end] = arr;

  const isValidStart = !!start && dayjs(start, "DD/MM/YYYY", true).isValid();
  const isValidEnd = !!end && dayjs(end, "DD/MM/YYYY", true).isValid();

  return {
    dateStart: isValidStart ? dayjs(start, "DD/MM/YYYY").format("YYYY/MM/DD") : undefined,
    dateEnd: isValidEnd ? dayjs(end, "DD/MM/YYYY").format("YYYY/MM/DD") : undefined
  };
}

export const generateColumnsFromCodes = (
  codes: ColumnKey[],
  customerFields: ICustomerFields[],
  actionColumn?: TableColumnsType<DataType>[number]
): TableColumnsType<DataType> => {
  const sortedFields = codes
    .map(code => customerFields.find(field => field.fieldCode === code))
    .filter(Boolean)
    .map(field => ({
      title: field!.fieldLabel,
      dataIndex: field!.fieldCode,
      key: field!.fieldCode,
      render: (_: any, record: DataType) => {
        const value = record.fields.find(f => f.fieldCode === field!.fieldCode)?.value;
        return value ?? '';
      },
    }));

  return actionColumn ? [actionColumn, ...sortedFields] : sortedFields;
};

export const getWidthFromHeader = (header: string, min = 80, max = 400) => {
  const width = header.length * 10 + 24
  const temp = Math.min(Math.max(width, min), max)
  return convertWidth(temp, 1440)
}

export const getWidthFromHeaderV2 = (header: string, min = 80, max = 400) => {
  if (!header || typeof header !== 'string') {
    return min; // Trả về width mặc định nếu header không hợp lệ
  }
  const width = header.length * 10 + 24
  const temp = Math.min(Math.max(width, min), max)
  return convertWidth(temp, 1440)
}

const convertWidth = (width: number, screen = 1440) => {
  const currentScreenWidth = window.innerWidth
  const columnWidth = Math.round((currentScreenWidth / screen) * width)
  return columnWidth
}

const checkTypeofObject = (value: any) => {
  if (!isArray(value)) {
    return value?.title ?? NO_DATA
  }

  switch (typeof value[0]) {
    case "object":
      return (
        // flex-wrap overflow-y-scroll overflow-x-hidden
        <div className='h-full d-flex  align-center gap-2 '>
          {
            value.map((item: any) => (
              <span
                key={item.id}
                className={`bg-${item.backgroundColor}  rounded-2 text-${item.color} text-xs px-2 d-flex align-center gap-3-px h-22-px font-regular`}
              >
                {item?.codeSymbol ?? item.code}
              </span>
            ))
          }
          {
            !value.length ?
              <span
                className={`  rounded-2  text-xs px-2 d-flex align-center gap-3-px h-22-px font-regular`}
              >
                {NO_DATA}
              </span> :
              null
          }
        </div>
      )
    case 'string':
      if (value.length && /^[0-9]+$/.test(value[0])) {
        return <span>{value.join(",")}</span>
      } else {
        return <div className='h-full d-flex  align-center gap-2 ' >
          {value.map((item: string, i: number) => (
            <span
              key={i}
              className={`bg-F0F5FF border-ADC6FF  rounded-2 text-2F54EB text-xs px-2 d-flex align-center gap-3-px h-22-px font-regular`}
            >
              {item ?? NO_DATA}
            </span>
          ))}
        </div>
      }
  }
}
//định dạng cho xuất excel
const checkTypeofObjectExcel = (value: any): string => {
  if (!isArray(value)) {
    // Nếu không phải mảng => lấy title hoặc giá trị gốc
    return value?.title ?? value ?? NO_DATA;
  }

  if (!value.length) return NO_DATA;

  switch (typeof value[0]) {
    case "object": {
      // ví dụ value = [{ id, codeSymbol, code, color, ... }]
      return value
        .map((item: any) => item?.codeSymbol ?? item?.code ?? NO_DATA)
        .join(", ");
    }

    case "string": {
      // // nếu là chuỗi toàn số (["123", "456"]) → ghép bằng dấu phẩy
      // if (/^[0-9]+$/.test(value[0])) {
      //   return value.join(",");
      // }
      // nếu là chuỗi chữ (["A", "B", "C"]) → ghép bằng dấu phẩy + khoảng trắng
      return value.join(", ");
    }

    default:
      // fallback: chuỗi JSON
      return JSON.stringify(value);
  }
};

const stringFieldTransformers: Record<string, (v: string) => any> = {
  cus_name: (v) => capitalizeEachWord(v),
  contact_name: (v) => capitalizeEachWord(v),
  trans_engine_no: (v) => v.toUpperCase(),
  own_chassis_no: (v) => v.toUpperCase(),
  own_engine_no: (v) => v.toUpperCase(),
  own_number_plate: (v) => v.toUpperCase(),
};

export const renderValueAsJSX = (value: any, fieldCode: string) => {

  // Xử lý đặc biệt cho cus_name
  // if (fieldCode === 'cus_name' && typeof value === 'string') {
  //   if (value) {
  //     return capitalizeEachWord(value);
  //   } else {
  //     return NO_DATA
  //   }

  // }



  // if (typeof value === 'string') {
  //   if (value) {
  //     if (fieldCode === 'cus_name') {
  //       return capitalizeEachWord(value)
  //     }
  //     if (fieldCode === 'trans_engine_no') {
  //       return value.toUpperCase()
  //     }

  //   } else {
  //     return NO_DATA
  //   }

  // }

  if (typeof value === 'string') {
    if (!value) return NO_DATA;

    const transformer = fieldCode ? stringFieldTransformers[fieldCode] : undefined;

    // console.log(fieldCode, value);

    return transformer ? transformer(value) : value;
  }

  switch (typeof (value)) {
    case 'string':
    case 'number':
    case 'bigint':
      return value
    case 'boolean':
      return value
    case 'object':
      return checkTypeofObject(value)
    default:
      return NO_DATA
  }
}
// in hoa chữ cái đầu
export const capitalizeEachWord = (str: string): string => {
  if (!str || typeof str !== 'string') return str || '';

  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

//định dạng cho xuất excel
export const renderValueAsExcel = (value: any, fieldCode?: string) => {
  // Xử lý đặc biệt cho cus_name
  if (fieldCode === 'cus_name' && typeof value === 'string') {
    if (value) {
      return capitalizeEachWord(value);
    } else {
      return NO_DATA
    }

  }
  switch (typeof (value)) {
    case 'string':

    case 'bigint':
      return value
    case 'number':
      return formatPrice(value ?? 0)
    case 'boolean':
      return value
    case 'object':
      return checkTypeofObjectExcel(value)
    default:
      return NO_DATA
  }
}


export const NOOP = () => { };

export type HeaderActions = {
  setDataFilterList: (dataFilterList: IDataDefaulFilterList) => void;
};

export type FilterHeaderExtras = {
  isDetailPage?: boolean;
  idCustomer?: number;
  dataFilterList: IDataDefaulFilterList;
  setDataFilterList: (dataFilterList: IDataDefaulFilterList) => void;
};

export const generateColumnsFromCodesAgGridReact = (
  codes: ColumnKey[],
  fields: ICustomerFields[],
  dataFilterList: IDataDefaulFilterList,
  actionColumn?: ColDef<any, any>,
  headerActions: HeaderActions = { setDataFilterList: NOOP },
): ColDef[] => {
  const baseColumns = codes
    ?.map(code => {
      const field = fields.find(f => f.fieldCode === code)
      if (!field) return null
      const headerExtras: FilterHeaderExtras = {
        dataFilterList,
        setDataFilterList: headerActions.setDataFilterList,

      }




      return {
        headerName: field.fieldLabel,
        headerComponent: FilterHeader,
        headerComponentParams: headerExtras, // chỉ extras
        field: field.fieldCode,
        colId: field.fieldCode,
        sortable: true,
        maxWidth: 1000,
        width: getWidthFromHeader(field.fieldLabel),
        cellRenderer: (params: any) => renderValueAsJSX(params.value, field.fieldCode)
      } as ColDef
    })
    .filter(Boolean) as ColDef[]

  return actionColumn ? [actionColumn, ...baseColumns] : baseColumns
}

// Hàm chuyển đổi
export const mapToSelectOptions = (
  list: IOperatorFieldConditionsGroup[]
): ISelectOption[] => {
  return list.map(item => ({
    value: item.id,
    label: item.label
  }));
};

export const checkDisabledPermission = (
  isAccess: boolean
): string => {
  return isAccess ? "" : "disabled"
};

// menu check
export function getDeepestFirstChildUrl(
  menu: IMenu | IMenu[] | undefined | null, isClickLogo: boolean = false
): string | null {

  if (!menu) {
    return isClickLogo ? '/login' : '/unauthorized';
  }

  let current: IMenu | undefined =
    Array.isArray(menu) ? menu[0] : menu;

  while (current?.childrenMenu?.length) {
    current = current.childrenMenu[0];
  }

  return current?.menuUrl ?? null;
}



export function isCurrentPathInMenu(
  menu: IMenu[],
  permissionSlice: IPermission[],
  currentPath: string
): boolean {
  const cleanPath = currentPath.replace(/\/+$/, "");

  // 1. Always allowed (prefix match)
  if (alwaysPageAllowed.some(path => cleanPath.startsWith(path))) {
    return true;
  }

  // 2. Permission check
  const { isAccess } = getUserPermissions(permissionSlice, cleanPath);
  if (isAccess) return true;

  // 3. Skip menu check if explicitly blocked
  if (!alwaysPageAllowedNotKey.includes(cleanPath)) {
    return false;
  }

  // 4. Iterative DFS menu traversal
  const stack: IMenu[] = [...menu];

  while (stack.length) {
    const item = stack.pop()!;
    if (!item.menuUrl) continue;

    const itemUrl = item.menuUrl.replace(/\/+$/, "");

    // Exact match
    if (cleanPath === itemUrl) return true;

    // Child path match
    if (cleanPath.startsWith(itemUrl + "/")) {
      const nextSegment = cleanPath
        .slice(itemUrl.length + 1)
        .split("/")[0];

      const hasValidChild = item.childrenMenu?.some(child => {
        if (!child.menuUrl) return false;
        const childSegment = child.menuUrl
          .replace(/\/+$/, "")
          .split("/")
          .pop();
        return childSegment === nextSegment;
      });

      if (hasValidChild) return true;
    }

    if (item.childrenMenu?.length) {
      stack.push(...item.childrenMenu);
    }
  }

  return false;
}



export type PermissionKey = 'access' | 'add' | 'edit' | 'delete' | 'upload' | 'download' | 'approve' | 'share'

export function getUserPermissions(permissionSlice: IPermission[], currentPath: string) {
  const keys: PermissionKey[] = [
    'access', 'add', 'edit', 'delete', 'upload', 'download', 'approve', 'share'
  ]

  const parts = currentPath.split('/').filter(Boolean)
  const last = parts[parts.length - 1] as PermissionKey

  // Kiểm tra 1: có /PermissionKey
  const isAction = keys.includes(last)

  const action = isAction ? last : null
  const baseUrl = isAction
    ? '/' + parts.slice(0, -1).join('/')
    : currentPath

  // Tìm quyền đúng menu
  const p = permissionSlice.find(x => x.menuUrl === baseUrl)

  if (!p)
    return {
      access: false,
      add: false,
      edit: false,
      delete: false,
      upload: false,
      download: false,
      share: false,
      approve: false,
      action,
      isAccess: false

    }

  // Nếu có action → lấy quyền tương ứng từ object p[action]
  const isAccess = action ? p[action] : true

  return {
    access: p.access,
    add: p.add,
    edit: p.edit,
    delete: p.delete,
    upload: p.upload,
    download: p.download,
    share: p.share,
    approve: p.approve,
    action,
    isAccess

  }

}

export const disabledDate: DatePickerProps['disabledDate'] = (current: any | null) => {
  if (!current) {
    return false;
  }
  // Ngày hiện tại
  const today = dayjs().startOf('day');
  // Ngày hiện tại + 1
  // const minDate = today.add(1, 'day');
  return current.isBefore(today, 'day');
};


export const getLastIdList = (data: ICustomer[]) => {
  const id = data.at(-1)?.id
  // const ids = data
  //   .map(c => c.id)
  //   .filter((id): id is number => typeof id === 'number')
  return id ?? undefined
}

export const getLastPriorityList = (data: ICustomer[]) => {
  const priority = data.at(-1)?.priority
  // const ids = data
  //   .map(c => c.id)
  //   .filter((id): id is number => typeof id === 'number')
  return priority ?? undefined
}

export const getLastItemList = (data: ICustomer[]): IItemLast | undefined => {
  const item = data.at(-1)
  if (!item) return undefined

  return {
    lastId: item.id,
    updatedAt: item.updatedAt,
  }
}

export const formatIssuingUnitTree = (
  data: IIssuingUnit[]
): TreeSelectProps['treeData'] => {
  return data?.map(item => ({
    value: item.id,
    title: item.title?.toUpperCase(),
    children: item.children?.length
      ? formatIssuingUnitTree(item.children)
      : undefined,
  }));
};

export const flattenFields = (data: any[]) =>
  data.flatMap((choice) =>
    choice.fields.map((field: any) => ({
      ...field,
      parentId: choice.id,
    }))
  );


// #region Chi tiết KH



export const convertToAntdOptions = (
  data: ICarForInfomation[]
): any[] => {
  return data
    .filter(group => group.children && group.children.length > 0) // bỏ group rỗng nếu muốn
    .map(group => ({
      label: (
        <span>
          {group.label} ({group.total})
        </span>
      ),
      title: group.label,
      options: group.children.map(child => ({
        label: <span>{child.title}</span>,
        value: child.vehicleId,// nếu id = null => tên xe là Không xác định
        carId: child.id
      })),
    }));
};


export const convertToAntdOptionsV2 = (
  data: ICarForInfomation[]
): any[] => {
  return data
    .filter(group => group.children && group.children.length > 0) // bỏ group rỗng nếu muốn
    .map(group => ({
      label: (
        <span>
          {group.label} ({group.total})
        </span>
      ),
      title: group.label,
      options: group.children.map(child => ({
        label: <span>{child.title}</span>,
        value: `${child.vehicleId}-${child.id}`,
      })),
    }));
};

export const createGroupedSelectOptions = (
  data: ICarForInfomation[]
): SelectProps["options"] => {
  return data
    .filter(group => group.children && group.children.length > 0) // bỏ group rỗng nếu muốn
    .map(group => ({
      label: (
        <span>
          {group.label} ({group.total})
        </span>
      ),
      title: group.label,
      options: group.children.map(child => ({
        label: <span>{child.title}</span>,
        value: child.vehicleId ?? child.id,
      })),
    }));
};

export const createGroupedSelectOptionsV2 = (
  data: selectOptionsApi.ISLContractsAndInvoices[]
): SelectProps["options"] => {
  return data
    .filter(group => group.children && group.children.length > 0) // bỏ group rỗng nếu muốn
    .map(group => ({
      label: (
        <span>
          {group.label} ({group.total})
        </span>
      ),
      title: group.label,
      options: group.children.map(child => ({
        label: <span>{child.contractNo ?? child.invoiceServiceDocNo}</span>,
        value: child.contractNo ? child.contractNo + '-%-' + child.type : child.invoiceServiceDocNo + '-%-' + child.type,
      })),
    }));
};
//#endregion


// hàm tìm value theo fieldCode trong mảng data
export const getValueByFieldCode = (data: any[], fieldCode: string) => {
  return data.find(item => item.fieldCode === fieldCode)?.value
}


// hàm lấy chuỗi trong <>
export const extractTextInsideAngleBrackets = (text: string): {
  link: string;
  content: string;
} => {
  const match = text.match(/<([^>]+)>/);
  return {
    link: match?.[1] ?? "",
    content: text.replace(/<[^>]+>/, "").trim(),
  }
}
// hèm gender ra Link
export const genderLinkForLog = (
  data: ISystemLog | undefined
): JSX.Element => {
  if (!data?.customerId) {
    return <Tooltip
      placement="right"
      color="white"
      title={
        <span className="custom-page-css " style={{ color: "#000" }}>
          {data?.description}
        </span>
      }
    >
      <span className="custom-page-css">
        {data?.description}
      </span>
    </Tooltip>

    // <span>{data?.description}</span>;
  }

  const match = data.description.match(/<([^>]+)>/);

  if (!match) {
    return <Tooltip
      placement="right"
      color="white"
      title={
        <span className="custom-page-css " style={{ color: "#000" }}>
          {data?.description}
        </span>
      }
    >
      <span className="custom-page-css">
        {data?.description}
      </span>
    </Tooltip>
  }

  const linkText = match[1];

  let linkTo = "";
  let state = {};

  switch (data.moduleId) {
    case ModuleTypeLog.Customer:
      linkTo = "/customer/list/edit/";
      state = {
        firstPage: "/system-configuration/activity-log",
        id: data.customerId,
      };
      break;

    case ModuleTypeLog.CustomerGroup:
      linkTo = "/customer/group";
      state = {
        action: "view",
        item: {
          key: data.customerId.toString(),
        },
      };
      break;

    case ModuleTypeLog.Vehicle:
      linkTo = "/vehicle-management/vehicles";
      break;

    default:
      break;
  }

  const parts = data.description.split(match[0]);

  return (
    <Tooltip
      placement="right"
      color="white"
      title={
        <span className="custom-page-css " style={{ color: "#000" }}>
          {parts[0]}

          {linkText}

          {parts[1]}
        </span>
      }
    >
      <span className="custom-page-css">
        {parts[0]}

        <Link
          to={linkTo}
          state={state}
          className="text-096DD9"
        >
          {linkText}
        </Link>

        {parts[1]}
      </span>
    </Tooltip>

  );
};
// hèm gender ra Link
export const genderLinkForLogV2 = (
  data: HistorySummary | undefined
): JSX.Element => {
  if (!data?.customerId) {
    return <Tooltip
      placement="right"
      color="white"
      title={
        <span className="custom-page-css " style={{ color: "#000" }}>
          {data?.description}
        </span>
      }
    >
      <span className="custom-page-css">
        {data?.description}
      </span>
    </Tooltip>

    // <span>{data?.description}</span>;
  }

  const match = data.description.match(/<([^>]+)>/);

  if (!match) {
    return <Tooltip
      placement="right"
      color="white"
      title={
        <span className="custom-page-css " style={{ color: "#000" }}>
          {data?.description}
        </span>
      }
    >
      <span className="custom-page-css">
        {data?.description}
      </span>
    </Tooltip>
  }

  const linkText = match[1];

  let linkTo = "";
  let state = {};

  switch (data.moduleId) {
    case ModuleTypeLog.Customer:
      linkTo = "/customer/list/edit/";
      state = {
        firstPage: "/system-configuration/activity-log",
        id: data.customerId,
      };
      break;

    case ModuleTypeLog.CustomerGroup:
      linkTo = "/customer/group";
      state = {
        inforNodeEvent: {
          action: "view",
          item: {
            key: data.customerId.toString(),
            title: linkText,
            level: data?.level,
            parentId: data?.parentId,
          },
        }

      };
      break;

    case ModuleTypeLog.Vehicle:
      linkTo = "/vehicle-management/vehicles";
      break;

    default:
      break;
  }

  const parts = data.description.split(match[0]);

  return (
    <Tooltip
      placement="right"
      color="white"
      title={
        <span className="custom-page-css w-full " style={{ color: "#000" }}>
          {parts[0]}

          {linkText}

          {/* {parts[1]} */}
          <div dangerouslySetInnerHTML={{ __html: parts[1] }}></div>
        </span>
      }
    >
      <span className="custom-page-css">
        {parts[0]}

        <Link
          to={linkTo}
          state={state}
          className="text-096DD9"
        >
          {linkText}
        </Link>


        {/* {parts[1]} */}
        <div dangerouslySetInnerHTML={{ __html: parts[1] }}></div>
      </span>
    </Tooltip>

  );
};


// hèm gender ra Link
export const genderLinkForLogV3 = (
  data: HistorySummary | undefined
): JSX.Element => {
  if (!data) return <span>{''}</span>;
  const match = data.description.match(/<([^>]+)>/);

  if (!match) {
    return <Tooltip
      placement="right"
      color="white"
      title={
        <span className="custom-page-css " style={{ color: "#000" }}>
          {data?.description}
        </span>
      }
    >
      <span className="custom-page-css">
        {data?.description}
      </span>
    </Tooltip>
  }

  const linkText = match[1];

  let linkTo = "";
  let state = {};

  const parts = data.description.split(match[0]);

  return (
    <Tooltip
      placement="right"
      color="white"
      title={
        <span className="custom-page-css w-full " style={{ color: "#000" }}>
          {parts[0]}

          {linkText}

          {/* {parts[1]} */}
          <div dangerouslySetInnerHTML={{ __html: parts[1] }}></div>
        </span>
      }
    >
      <span className="custom-page-css">
        {parts[0]}

        {linkText}


        {/* {parts[1]} */}
        <div dangerouslySetInnerHTML={{ __html: parts[1] }}></div>
      </span>
    </Tooltip>

  );
};

export const genderLinkForLogV4 = (
  data: HistorySummary | undefined
): JSX.Element => {
  if (!data?.customerId) {
    return <Tooltip
      placement="right"
      color="white"
      title={
        <span className="custom-page-css " style={{ color: "#000" }}>
          {data?.description}
        </span>
      }
    >
      <span className="custom-page-css">
        {data?.description}
      </span>
    </Tooltip>

    // <span>{data?.description}</span>;
  }

  const match = data.description.match(/<([^>]+)>/);

  if (!match) {
    return <span className="custom-page-css">
      {data?.description}
    </span>
  }

  const linkText = match[1];

  let linkTo = "";
  let state = {};

  switch (data.moduleId) {
    case ModuleTypeLog.Customer:
      linkTo = "/customer/list/edit/";
      state = {
        firstPage: "/system-configuration/activity-log",
        id: data.customerId,
      };
      break;

    case ModuleTypeLog.CustomerGroup:
      linkTo = "/customer/group";
      state = {
        inforNodeEvent: {
          action: "view",
          item: {
            key: data.customerId.toString(),
            title: linkText,
            level: data?.level,
            parentId: data?.parentId,
          },
        }

      };
      break;

    case ModuleTypeLog.Vehicle:
      linkTo = "/vehicle-management/vehicles";
      break;

    default:
      break;
  }

  const parts = data.description.split(match[0]);

  return (
    <span className="custom-page-css">
      {parts[0]}

      <Link
        to={linkTo}
        state={state}
        className="text-096DD9"
      >
        {linkText}
      </Link>


      {/* {parts[1]} */}
      <div dangerouslySetInnerHTML={{ __html: parts[1] }}></div>
    </span>

  );
};

//#region Validate input số chỉ cho nhập số, không cho nhập âm, tối đa 12 chữ số

const hasNegativeSign = (value: string) => {
  return value.includes('-');
};

const hasInvalidCharacter = (value: string) => {
  // Cho phép số, dấu chấm, dấu trừ để validator tự báo lỗi âm
  return /[^\d.-]/.test(value);
};

const getRawNumberString = (value: unknown) => {
  return String(value || '').replace(/\./g, '');
};

const getDigitsOnly = (value: string) => {
  return value.replace(/\D/g, '');
};

const formatNumberWithDot = (value: string) => {
  const rawValue = getDigitsOnly(value);

  return rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const normalizeNumberInput = (value: string) => {
  const digitsOnly = getDigitsOnly(value);

  // Nếu nhập ký tự lạ thì giữ nguyên để validator báo lỗi
  if (hasInvalidCharacter(value)) {
    return value;
  }

  // Nếu nhập dấu âm thì giữ nguyên để validator báo lỗi "Không được nhập số âm"
  if (hasNegativeSign(value)) {
    return value;
  }

  // Nếu nhập quá 12 chữ số thì giữ nguyên để validator báo lỗi
  if (digitsOnly.length > MAX_DIGITS) {
    return value;
  }

  // Hợp lệ thì format
  return formatNumberWithDot(value);
};


export const validatePositiveNumberMax12 = (_: unknown, value: unknown) => {
  const text = String(value || '');

  if (!text) {
    return Promise.resolve();
  }

  if (hasInvalidCharacter(text)) {
    return Promise.reject(new Error('Chỉ được nhập số'));
  }

  if (hasNegativeSign(text)) {
    return Promise.reject(new Error('Không được nhập số âm'));
  }

  const rawValue = getRawNumberString(text);

  if (!/^\d+$/.test(rawValue)) {
    return Promise.reject(new Error('Chỉ được nhập số'));
  }

  if (rawValue.length > MAX_DIGITS) {
    return Promise.reject(new Error('Tối đa 12 chữ số'));
  }

  if (Number(rawValue) <= 0) {
    return Promise.reject(new Error('Giá trị phải lớn hơn 0'));
  }

  return Promise.resolve();
};
//#endregion







export const buildOptionsV2 = (data: selectOptionsApi.ISLCustomerFields[]): OptionData[] => {
  return data
    // .sort((a, b) => a.sortOrder - b.sortOrder)
    .flatMap((group) => [
      {
        key: `group-${group.id}`,
        isGroup: true as const,
        title: group.title,
        fieldCode: '',
      },
      ...group.children.map((item) => ({
        key: `${item.id}-${item.fieldCode}-group-${group.id}`,
        value: item.id,
        label: item.fieldLabel,
        isGroup: false as const,
        parentKey: `group-${group.id}`,
        id: item.id,
        fieldCode: item.fieldCode,
        fieldLabel: item.fieldLabel,
        // inputType: item.inputType,
        // type: item.type
      })),
    ]);
};

export const CustomLoadingOverlayTable = () => (
  <Spin className="spin-tb-loading" />
)



export const mapDocCode = (code?: string) => {
  if (code === 'F3' || code === 'F1') return 'F3';
  if (code === 'F2' || code === 'FB') return 'F2';
  if (code === 'QA' || code === 'QS') return 'QA';
  if (code === 'S1') return 'S1';
  if (code === null) return 'Khác';
  return code;
};



export const formatDateV2 = (date: Date) => {

  const formatted = dayjs(date).format("YYYY/MM/DD");

  return formatted;
}




dayjs.extend(customParseFormat);

export const convertDateValue = (value: any) => {
  if (!value || typeof value !== "object") {
    return value;
  }

  const convert = (date?: string) => {
    if (!date) return date;

    const parsed = dayjs(date, "DD/MM/YYYY", true);

    return parsed.isValid()
      ? parsed.format("YYYY-MM-DD")
      : date;
  };

  return {
    ...value,

    ...(value.valueDate !== undefined && {
      valueDate: convert(value.valueDate),
    }),

    ...(value.valueDateStart !== undefined && {
      valueDateStart: convert(value.valueDateStart),
    }),

    ...(value.valueDateEnd !== undefined && {
      valueDateEnd: convert(value.valueDateEnd),
    }),
  };
};


const convertConditionFilterDates = (
  data: IVConditionFilterADD
): IVConditionFilterADD => {
  return {
    ...data,

    conditions: data.conditions.map(condition => ({
      ...condition,

      value: convertDateValue(condition.value),
    })),
  };
};



export const getEditClass = (view?: boolean, edit?: boolean) => {
  if (edit && view) return ''
  if (!view) return 'd-none'
  if (!edit && view) return 'disabled'
}


export const getPermissionClass = (checkPermission?: boolean) => {
  return checkPermission ? '' : 'disabled'
}